export const queue = {
	'data-saved': "Aaaah bah voilà, vos données ont bien été sauvegardées finalement.",
	"save-failed": "La sauvegarde a de nouveau échoué ( oui, encore :-( ). Continuez, on se charge de <strong>réessayer</strong> dans 5 minutes. <strong>Mais restez connecté, sinon, on ne pourra rien faire</strong>."
}
